import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function RoundCheckboxBlankIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
      fill='none'
    >
      <rect
        x='0.5'
        y='0.5'
        width='15'
        height='15'
        rx='3.5'
        fill={props.fill ?? 'none'}
        stroke={props.stroke ?? '#D1D4D9'}
      />
    </SvgIcon>
  );
}
